import { createContext, useState } from 'react'

export enum AlertSortTypeEnum {
  SEVERITY = 'severity',
  ASCENDING_DATE = 'ascending-date',
  DESCENDING_DATE = 'descending-date',
}

export interface IAlertSeverityFilter {
  critical: boolean
  high: boolean
  elevated: boolean
  low: boolean
  informational: boolean
}

export interface IAlertCategoryFilter {
  versioning: boolean
  vulnerability: boolean
  userBehavior: boolean
  attackBehavior: boolean
  systemBehavior: boolean
  general: boolean
}

export interface IAlertFilters {
  alertSeverity: IAlertSeverityFilter
  alertCategory: IAlertCategoryFilter
  sortBy: string
}

export const defaultAlertFilters = {
  alertSeverity: {
    critical: false,
    high: false,
    elevated: false,
    low: false,
    informational: false,
  },
  alertCategory: {
    versioning: false,
    vulnerability: false,
    userBehavior: false,
    attackBehavior: false,
    systemBehavior: false,
    general: false,
  },
  sortBy: AlertSortTypeEnum.SEVERITY as string,
}

export const GeneralContext = createContext({
  selectedAlertIds: [] as string[],
  setSelectedAlertIds: (ids: string[]) => {},
  isSelectedPage: false,
  setIsSelectedPage: (isSelectedPage: boolean) => {},
  alertFilters: {
    alertSeverity: {
      critical: false,
      high: false,
      elevated: false,
      low: false,
      informational: false,
    },
    alertCategory: {
      versioning: false,
      vulnerability: false,
      userBehavior: false,
      attackBehavior: false,
      systemBehavior: false,
      general: false,
    },
    sortBy: AlertSortTypeEnum.SEVERITY as string,
  },
  setAlertFilters: (filters: IAlertFilters) => {},
})

interface GeneralContextProviderProps {
  children: React.ReactNode
}

export const GeneralContextProvider = ({
  children,
}: GeneralContextProviderProps) => {
  const [selectedAlertIds, setSelectedAlertIds] = useState<string[]>([])
  const [isSelectedPage, setIsSelectedPage] = useState<boolean>(false)
  const [alertFilters, setAlertFilters] =
    useState<IAlertFilters>(defaultAlertFilters)

  return (
    <GeneralContext.Provider
      value={{
        selectedAlertIds,
        setSelectedAlertIds,
        alertFilters,
        setAlertFilters,
        isSelectedPage,
        setIsSelectedPage,
      }}
    >
      {children}
    </GeneralContext.Provider>
  )
}
